export default __webpack_public_path__ + "7ddd874de070e75bc244e0a1caf1e985.png";